import { reactive } from 'vue';

const TOAST_TIMEOUT_MS = Object.freeze({
    success: 4000,
    info: 4000,
    error: 8000,
});

const state = reactive({ items: [] });
let nextId = 1;

const dismiss = (id) => {
    const index = state.items.findIndex(toast => toast.id === id);
    if (index !== -1) state.items.splice(index, 1);
};

const push = (type, message) => {
    const id = nextId++;
    state.items.push({ id, type, message });
    setTimeout(() => dismiss(id), TOAST_TIMEOUT_MS[type]);
    return id;
};

/**
 * Глобальная очередь уведомлений; рендерит её ToastHost.
 */
export const useToast = () => ({
    toasts: state.items,
    success: message => push('success', message),
    info: message => push('info', message),
    error: message => push('error', message),
    dismiss,
});
